import { Link } from 'react-router-dom';
import { CheckCircle, Circle } from 'phosphor-react';
import { LESSONS } from '../data/lessons';
import { useUserStore } from '../store/userStore';
import { Card } from '../components/common/Card';
import { Page } from '../components/layout/Page';

export const Lessons = () => {
  const { completedLessons } = useUserStore();

  return (
    <Page className="space-y-8">
      <section className="glass-panel p-7 md:p-10 relative overflow-hidden">
        <div className="absolute -top-28 -right-24 w-72 h-72 rounded-full bg-nileBlue/18 blur-3xl" />
        <div className="absolute -bottom-28 -left-24 w-80 h-80 rounded-full bg-gold/18 blur-3xl" />

        <div className="relative space-y-3">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900">الدروس التعليمية</h1>
          <p className="text-gray-700 max-w-3xl">
            وحدة مكثفة للصف الخامس والسادس: شرح مبسط + أسئلة + أنشطة. هدفنا إنك تفهم الموارد وتستخدمها بحكمة.
          </p>
          <div className="flex flex-wrap gap-2">
            <span className="chip chip-strong">3 دروس</span>
            <span className="chip">اختبارات قصيرة</span>
            <span className="chip">أنشطة رسم وملاحظة</span>
            <span className="chip">مفردات جديدة</span>
          </div>
        </div>
      </section>

      <Card className="space-y-4">
        <h2 className="text-2xl font-black text-gray-900">ماذا ستتعلم في هذه الوحدة؟</h2>
        <p className="text-gray-700">
          ستتعلم عن الموارد المعدنية ومصادر الطاقة والمياه والزراعة في مصر، مع أمثلة عملية وأسئلة تساعدك على التفكير.
        </p>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {LESSONS.map((lesson) => {
          const isCompleted = completedLessons.includes(lesson.id);

          return (
            <Link key={lesson.id} to={`/lessons/${lesson.id}`}>
              <div className="glass-panel p-6 rounded-3xl relative overflow-hidden group">
                <div
                  className="absolute inset-x-0 top-0 h-1.5"
                  style={{ backgroundColor: lesson.color }}
                />
                <div className="absolute -right-14 -top-14 w-40 h-40 rounded-full opacity-20 blur-2xl" style={{ backgroundColor: lesson.color }} />

                <div className="relative flex items-start gap-4">
                  <div className="text-5xl">{lesson.icon}</div>
                  <div className="flex-1 space-y-3">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h3 className="text-2xl font-black text-gray-900">{lesson.title}</h3>
                        <p className="text-sm text-gray-700">{lesson.description}</p>
                      </div>
                      {isCompleted ? (
                        <CheckCircle size={30} weight="fill" className="text-palmGreen" />
                      ) : (
                        <Circle size={30} className="text-gray-300" />
                      )}
                    </div>

                    <div className="flex flex-wrap gap-2">
                      <span className="chip">⏱️ {lesson.duration}</span>
                      <span className="chip">🧩 {lesson.sections} أقسام</span>
                      <span className="chip">❓ {lesson.quiz} أسئلة</span>
                      <span className="chip chip-strong number">+{lesson.points} نقطة</span>
                    </div>

                    <div className="text-xs text-gray-500">
                      اضغط لفتح الدرس →
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </Page>
  );
};
